module.exports = function(service) {
	'use strict'
	service.factory('getIspTitle', getIspTitle);
	getIspTitle.$inject = [];
	function getIspTitle() {
	   return function(title) {
            if(!title) return;
            if(title.includes("isp.", 0)) {
                title = title.substring(4, title.length)
            }
            return title.split('_').join(' ')
        }
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/getIspTitleService.js
// module id = 606
// module chunks = 0